import AdminMenuId from "../../../utils/constants/AdminMenuId";
import "../../../css/userManagementPage/UserManagement.css"
import UserRegisterModal from "./modal/UserRegisterModal";
import MessageSendingModal from "./modal/MessageSendingModal";
import { useEffect, useState } from "react";
import UserList from "./UserList";
import { limitInputNumber, pressEnter } from "../../../utils/Utils";
import UserManagementFilter from "./UserManagementFilter";
import TeacherConstant from "../../../utils/constants/TeacherConstant";
import UserDetailsModal from "./modal/UserDetailsModal";
import UserLessonListModal from "../../modal/UserLessonListModal";
import UserEditModal from "./modal/UserEditModal";
import PaymentHistoryModal from "../../modal/PaymentHistoryModal";
import proxy from "../../../utils/Proxy";
import { BigButton } from "../../../elements/button/Button";

let UserManagementPage = (props) => {
    let [userInput, setUserInput] = useState({ filter: 0, name: "", birth: "", contact: "" })
    let [registerIsOpen, setRegisterIsOpen] = useState(false)
    let [messageSendingIsOpen, setMessageSendingIsOpen] = useState(false)
    let [needUpdate, setNeedUpdate] = useState(false)
    let [detailIsOpen, setDetailIsOpen] = useState(false)
    let [editIsOpen, setEditIsOpen] = useState(false)
    let [lessonListIsOpen, setLessonListIsOpen] = useState(false)
    let [paymentHistoryIsOpen, setPaymentHistoryIsOpen] = useState(false)
    let [currentPage, setCurrentPage] = useState(1)
    let [detailData, setDetailData] = useState({})
    let [data, setData] = useState({})
    let [checkboxMap, setCheckboxMap] = useState(new Map())

    let search = () => {
        setCurrentPage(1)
        let year = document.getElementById("user-management-page-search-birth-year").value
        let month = document.getElementById("user-management-page-search-birth-month").value
        let day = document.getElementById("user-management-page-search-birth-day").value
        if (month.length === 1) month = "0" + month
        if (day.length === 1) day = "0" + day
        let birth = year + "%-%" + month + "%-%" + day

        let input = {}
        input.name = document.getElementById("user-management-page-input-name").value
        input.birth = birth
        input.contact = document.getElementById("user-management-page-input-contact").value
        setUserInput(prevState => {
            return { ...prevState, ...input };
        })
    }

    let clickFilter = (filter) => {
        setUserInput(prevState => {
            return { ...prevState, filter: filter };
        })
        setCurrentPage(1)
        setCheckboxMap(prevState => {
            prevState.clear();
            return prevState;
        })
        document.getElementById("user-list-check-all").checked = false
        document.getElementById("user_list-check-all-pages-user").checked = false
    }

    let setUserDetailById = async (userid) => {
        let response = await Promise.all(
            [proxy.get("/adminapi/users", { params: { userid: userid } }),
            proxy.get("/adminapi/payments/users/" + userid + "/now")])
        let userJson = response[0].data.data[0]
        let paymentRes = response[1].data
        userJson = {
            ...userJson,
            isRegister: paymentRes.isRegister,
            register_message: paymentRes.message,
            paymentid: paymentRes.data.paymentid,
            register_start_date: paymentRes.data.start,
            register_end_date: paymentRes.data.end,
            startdate_non_set: paymentRes.data.startdate_non_set
        }
        if (userJson.teacher_in_charge === 0 || userJson.teacher_in_charge === null ||
            typeof userJson.teacher_in_charge === 'undefined') {
            userJson.teacher_in_charge = ""
        } else {
            let teacherIds = await proxy.get("/api/teachers")
            let teacher = teacherIds.data.data[userJson.teacher_in_charge];
            userJson.teacher_in_charge = TeacherConstant.major_symbol[teacher.major] + teacher.name
        }
        setDetailData(userJson)
    }

    let onRegister = async (getUserId) => {
        setNeedUpdate(true)
        let userid = getUserId()
        await setUserDetailById(userid)
        setRegisterIsOpen(false)
        setDetailIsOpen(true)
    }

    let onDetailButtonClick = async (e) => {
        let elementId = e.currentTarget.id
        let userid = parseInt(elementId.split("userDetail")[1])

        await setUserDetailById(userid)
        setDetailIsOpen(true)
    }

    let editClose = async (userid) => {
        if (userid !== undefined) {
            await setUserDetailById(userid)
            setNeedUpdate(true)
        }
        setEditIsOpen(false)
        setDetailIsOpen(true)
    }

    let editClick = () => {
        setEditIsOpen(true)
        setDetailIsOpen(false)
    }

    let onLessonListButtonClick = (e) => {
        let elementId = e.currentTarget.id
        let userid = parseInt(elementId.split("userDetail")[1])

        Promise.all([proxy.get("/api/teachers"),
        proxy.get("/adminapi/users", { params: { userid: userid } })]).then(resultList => {
            let data = {}
            data.teachers = resultList[0].data.data;
            setData(data)
            let userJson = resultList[1].data.data[0]
            setDetailData(userJson)
            setLessonListIsOpen(true)
        })
    }
    let onPaymentListButtonClick = (e) => {
        let elementId = e.currentTarget.id
        let userid = parseInt(elementId.split("userDetail")[1])
        proxy.get("/adminapi/users", { params: { userid: userid } }).then(usersResponse => {
            let userJson = usersResponse.data.data[0]
            setDetailData(userJson)
            setPaymentHistoryIsOpen(true)

        })
    }

    useEffect(() => {
        let inputs = document.querySelectorAll(".user-management-enter-binding")
        inputs.forEach((input) => input.addEventListener('keydown', e => pressEnter(e, search)))
        return () => {
            inputs.forEach(input => input.removeEventListener('keydown', e => pressEnter(e, search)))
        }
    }, [])
    return (
        <div className="content-container">
            <div className="user-management-page-header">
                <div className="title-selector-container">
                    <div className="user-management-page-title-container">
                        <p className="content-title">{AdminMenuId.text[AdminMenuId.USER_MANAGEMENT]}</p>
                    </div>
                    <div className="user-management-page-search-filter-container">
                        <div className="user-management-page-search-filter-icon"></div>
                        <UserManagementFilter current={userInput.filter} onClickDropdown={clickFilter} />
                    </div>

                    <div className="user-management-page-search-container">
                        <div className="user-management-page-search-box">
                            <input className="user-management-page-search-input user-management-enter-binding"
                                id="user-management-page-input-name"
                                placeholder="이름 검색" onBlur={(e) => e.target.placeholder = "이름 검색"}
                                onFocus={(e) => e.target.placeholder = ""}></input>
                        </div>
                        <div className="user-management-page-search-box">
                            <div className="user-management-page-search-birth-wrapper">
                                <input className="user-management-page-search-birth user-management-enter-binding"
                                    id="user-management-page-search-birth-year"
                                    placeholder="생일 년도" onBlur={(e) => e.target.placeholder = "생일 년도"}
                                    onFocus={(e) => e.target.placeholder = ""}
                                    onChange={e => limitInputNumber(e, 4)}></input>
                            </div>
                            <p>-</p>
                            <div className="user-management-page-search-birth-wrapper">
                                <input className="user-management-page-search-birth user-management-enter-binding"
                                    id="user-management-page-search-birth-month"
                                    placeholder="월" onBlur={(e) => e.target.placeholder = "월"}
                                    onFocus={(e) => e.target.placeholder = ""}
                                    onChange={e => limitInputNumber(e, 2)}></input>
                            </div>
                            <p>-</p>
                            <div className="user-management-page-search-birth-wrapper">
                                <input className="user-management-page-search-birth user-management-enter-binding"
                                    id="user-management-page-search-birth-day"
                                    placeholder="일" onBlur={(e) => e.target.placeholder = "일"}
                                    onFocus={(e) => e.target.placeholder = ""}
                                    onChange={e => limitInputNumber(e, 2)}></input>
                            </div>
                        </div>
                        <div className="user-management-page-search-last-box-button-wrapper">
                            <div className="user-management-page-search-box">
                                <input className="user-management-page-search-input user-management-enter-binding"
                                    id="user-management-page-input-contact"
                                    placeholder="휴대폰 번호 검색" onBlur={(e) => e.target.placeholder = "휴대폰 번호 검색"}
                                    onFocus={(e) => e.target.placeholder = ""}
                                    onChange={e => limitInputNumber(e, 12)}></input>
                            </div>
                            <div className="user-management-page-search-button" onClick={search}>
                                <div className="user-management-page-search-button-icon"></div>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="user-management-button-container">
                    <BigButton onClick={_ => setRegisterIsOpen(true)} label={"수강생 등록"} />
                    <BigButton onClick={_ => setMessageSendingIsOpen(true)} label={"문자 전송"} />
                </div>
                {registerIsOpen ?
                    <UserRegisterModal
                        onRegister={onRegister}
                        onCloseClick={() => setRegisterIsOpen(false)} /> : null}
                {messageSendingIsOpen ?
                    <MessageSendingModal
                        checkboxMap={checkboxMap}
                        filter={userInput.filter}
                        onCloseClick={() => setMessageSendingIsOpen(false)} /> : null}
                {detailIsOpen ?
                    <UserDetailsModal
                        data={detailData}
                        setDetailData={setDetailData}
                        onCloseClick={() => setDetailIsOpen(false)}
                        onEditClick={editClick} /> : null}
                {editIsOpen ?
                    <UserEditModal
                        data={detailData}
                        onCloseClick={editClose} /> : null}
                {lessonListIsOpen ?
                    <UserLessonListModal
                        setOpened={setLessonListIsOpen.bind(this)}
                        opened={lessonListIsOpen}
                        userid={parseInt(detailData.userid)}
                        username={detailData.name}
                        data={data} /> : null}
                {paymentHistoryIsOpen ?
                    <PaymentHistoryModal
                        setOpened={setPaymentHistoryIsOpen.bind(this)}
                        opened={paymentHistoryIsOpen}
                        userid={parseInt(detailData.userid)}
                        username={detailData.name}
                        lesson_count={detailData.lesson_count}/> : null}
            </div>
            <div className="user-management-page-body">
                <div className="user-management-body-border"></div>
                <UserList location={props.location}
                    userInput={userInput}
                    needUpdate={needUpdate}
                    currentPage={currentPage}
                    onCurrentPageChange={(page) => setCurrentPage(page)}
                    onUpdate={() => setNeedUpdate(false)}
                    onDetailButtonClick={onDetailButtonClick}
                    onLessonListButtonClick={onLessonListButtonClick}
                    onPaymentListButtonClick={onPaymentListButtonClick}
                    checkboxMap={checkboxMap}
                    onChangeCheckboxMap={setCheckboxMap} />
            </div>
        </div>)
}

export default UserManagementPage;